import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Permission } from '../security/permission';

@Injectable({
    providedIn: 'root'
})
export class PermissionService {

    private httpOptions(session: string) {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json', 'Authorization': 'Bearer ' + session
        }),
      };
    };

    private permissionsSubject = new BehaviorSubject<Set<string>>(new Set());
    private loadedSubject = new BehaviorSubject<boolean>(false);
    private currentUserId: string = '';

    constructor(private http: HttpClient) { }

    loadPermissions(): Observable<void> {
        let token = '';
        try {
            token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
        } catch(e) {}
        
        return this.http.get<string[]>(environment.permissionsUrl + '/me', this.httpOptions(token)).pipe(
            tap(perms => {
                this.permissionsSubject.next(new Set(perms));
                this.loadedSubject.next(true);
            }),
            map(() => void 0),
            catchError(() => {
                this.permissionsSubject.next(new Set());
                this.loadedSubject.next(true);
                return of(void 0);
            })
        );
    }

    hasPermission(permission: Permission): boolean {
        return this.permissionsSubject.value.has(permission);
    }

    hasPermission$(permission: Permission): Observable<boolean> {
        return this.permissionsSubject.asObservable().pipe(
            map(perms => perms.has(permission))
        );
    }

    hasAnyPermission(...permissions: Permission[]): boolean {
        return permissions.some(p => this.permissionsSubject.value.has(p));
    }

    isCurrentUser(userId: string): boolean {
        return this.currentUserId === userId;
    }

    get permissionsLoaded$(): Observable<boolean> {
        return this.loadedSubject.asObservable();
    }

    setCurrentUserId(userId: string): void {
        this.currentUserId = userId;
    }

    clear(): void {
        this.permissionsSubject.next(new Set());
        this.loadedSubject.next(false);
        this.currentUserId = '';
    }
}